import React from "react";
import {
  Container,
} from "@mui/material";
import { useParams } from "react-router-dom";
import Article1 from "./articles/Article1";
import Article2 from "./articles/Article2";
import Article3 from "./articles/Article3";
import Article4 from "./articles/Article4";
import Article5 from "./articles/Article5";
import Article6 from "./articles/Article6";
import Article7 from "./articles/Article7";
import Article8 from "./articles/Article8";
import Article9 from "./articles/Article9";
import Article10 from "./articles/Article10";
import Article11 from "./articles/Article11";
import Article12 from "./articles/Article12";


export default function Article(props: any) {
  const { id } = useParams();

  return (
    <div>
    <Container
      style={{
        padding: "24px",
        width: 1000,
        border: "#293241 solid 2px",
        boxShadow:
          "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
        maxWidth: "95%",
        backgroundColor: "#FFFFFF",
        marginBottom: "24px",
      }}
    >

      {id === "1" && <Article1 isDesktop={props.isDesktop}/>}
      {id === "2" && <Article2 isDesktop={props.isDesktop}/>}
      {id === "3" && <Article3 isDesktop={props.isDesktop}/>}
      {id === "4" && <Article4 isDesktop={props.isDesktop}/>}
      {id === "5" && <Article5 isDesktop={props.isDesktop}/>}
      {id === "6" && <Article6 isDesktop={props.isDesktop}/>}
      {id === "7" && <Article7 isDesktop={props.isDesktop}/>}
      {id === "8" && <Article8 isDesktop={props.isDesktop}/>}
      {id === "9" && <Article9 isDesktop={props.isDesktop}/>}
      {id === "10" && <Article10 isDesktop={props.isDesktop}/>}
      {id === "11" && <Article11 isDesktop={props.isDesktop}/>}
      {id === "12" && <Article12 isDesktop={props.isDesktop}/>}
    </Container >
    </div>
  );
}
